import { useState } from 'react';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase/config';

const useFileUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Test Firebase storage connection
  console.log('useFileUpload hook initialized');
  console.log('Storage object:', storage);

  const deleteFile = async (fileUrl) => {
    if (!fileUrl) return;
    
    // Check if it's a firebase storage URL
    if (!fileUrl.includes('firebasestorage.googleapis.com')) {
      console.log('Not a Firebase Storage URL, skipping storage deletion');
      return;
    }

    try {
      const fileRef = ref(storage, fileUrl);
      await deleteObject(fileRef);
      console.log('File deleted successfully from storage');
    } catch (error) {
      console.error('Error deleting file:', error);
      // We don't throw error here to allow the UI to proceed with clearing the field
      // but we log it for debugging
    }
  };

  const uploadFile = async (file, path) => {
    if (!file) return null;
    
    console.log('Starting file upload:', { fileName: file.name, fileSize: file.size, path });
    
    setUploading(true);
    setUploadProgress(0);
    
    try {
      const storageRef = ref(storage, path);
      console.log('Storage reference created:', storageRef);
      
      const snapshot = await uploadBytes(storageRef, file);
      console.log('File uploaded successfully:', snapshot);
      
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log('Download URL obtained:', downloadURL);
      
      setUploadProgress(100);
      return downloadURL;
    } catch (error) {
      console.error('Error uploading file:', error);
      console.error('Error details:', {
        code: error.code,
        message: error.message,
        stack: error.stack
      });
      throw error;
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  const uploadImage = async (file, fileName) => {
    const path = `books/images/${Date.now()}_${fileName}`;
    return await uploadFile(file, path);
  };

  const uploadPDF = async (file, fileName) => {
    const path = `books/pdfs/${Date.now()}_${fileName}`;
    return await uploadFile(file, path);
  };
  const uploadVideo = async (file, fileName) => {
    const path = `courses/videos/${Date.now()}_${fileName}`;
    return await uploadFile(file, path);
  };

  return {
    uploadImage,
    uploadPDF,
    uploadVideo,
    deleteFile,
    uploading,
    uploadProgress
  };
};

export default useFileUpload;
